// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"x1-z"};